import createWhereFilter, { WhereInput } from './createWhereFilter';

export default function transformWhereInput(key: string, fieldName?: string): WhereInput {
  return createWhereFilter(key, { key: fieldName });
}
